import React, {useEffect, useState} from 'react';
import {Section} from '../../components/Section';
import {Table} from '../../components/Table';
import {ViewUserCoupon} from "../../types/types";
import {couponDownLoad, getUserCoupons} from "../../apis/coupons";
import {nToast} from "../../plugins/reactToast";


export const MyCouponTable = () => {
    const [coupons, setCoupons] = useState<ViewUserCoupon[]>([])

    useEffect(() => {
        getCouponList()
    }, [])

    const clickDownloadBtn = (couponId: number) => {
        couponDownLoad({couponId: couponId}).then(r => {
            nToast('다운로드 완료 되었습니다');
            getCouponList();
        }).catch(e => console.log(e))
    }

    const getCouponList = () => {
        getUserCoupons().then(r => setCoupons(r.data.payload)).catch(e => console.log(e))
    }

    return (
        coupons.length === 0 ?
            <>
                <div className={'py-20 center text-center'}>
                    <p>쿠폰 내역이 없습니다.</p>
                </div>
            </>
            :
            <>
                {/* Mobile */}
                <Section className="md:hidden space-y-4 border-t pt-4 text-12">
                    {coupons
                        .sort((a, b) => {
                                if (a.usedCouponType > b.usedCouponType) return -1;
                                if (a.usedCouponType < b.usedCouponType) return 1;
                                return 0;
                            }
                        )
                        .sort((a,b) => b.couponId - a.couponId)
                        .map((coupon, index) => (
                        <div className="flex space-x-12 border-b pb-4" key={coupon.couponId}>
                            <div className=" space-y-2">
                                {[
                                    {title: 'No.'},
                                    {title: '발급방식'},
                                    {title: '쿠폰명'},
                                    {title: '발급기간(다운가능기간)'},
                                    {title: '유효기간(사용가능기간)'},
                                    {title: '지급 / 사용'},
                                ].map((item, index) => (
                                    <div className="text-gray-600" key={index}>{item.title}</div>
                                ))}
                            </div>

                            <div className="space-y-2">
                                <p className="">{index + 1}</p>
                                <p className="">{coupon.issuedType === 'ISSUED' ? '발급형' : '다운로드형'}</p>
                                <p className="">{coupon.name}</p>
                                <p className="">{coupon.issuedDateStr}</p>
                                <p className="">{coupon.validDateStr}</p>
                                <p
                                    className={`${
                                        coupon.usedCouponType === 'USE_C'
                                            ? 'text-blue-500'
                                            : coupon.usedCouponType === 'USE_Y'
                                                ? 'text-red-500'
                                                : coupon.usedCouponType === 'USE_N'
                                                    ? 'text-gray-500'
                                                    : ''
                                    }`}
                                >
                                    {coupon.usedCouponType === 'DOWN_Y' ? (
                                        <>
                                            <button
                                                onClick={() =>
                                                    clickDownloadBtn(coupon.couponId)
                                                }
                                                className="outlined-gray-900 py-2 px-4"
                                            >
                                                다운
                                            </button>
                                        </>
                                    ) : (
                                        <>{
                                            coupon.usedCouponType === 'USE_C'
                                                ? '사용완료'
                                                : coupon.usedCouponType === 'USE_Y'
                                                    ? '사용가능'
                                                    : coupon.usedCouponType === 'USE_N'
                                                        ? '사용불가'
                                                        : '다운불가'
                                        }</>
                                    )}
                                </p>
                            </div>
                        </div>
                    ))}
                </Section>

                {/* Desktop */}
                <Table className="hidden md:table mt-5">
                    <Table.Head>
                        <Table.Row>
                            <Table.Th>No.</Table.Th>
                            <Table.Th>발급방식</Table.Th>
                            <Table.Th>쿠폰명</Table.Th>
                            <Table.Th>발급기간(다운가능기간)</Table.Th>
                            <Table.Th>유효기간(사용가능기간)</Table.Th>
                            <Table.Th>지급 / 사용</Table.Th>
                        </Table.Row>
                    </Table.Head>
                    <Table.Body>
                        {coupons
                            .sort((a, b) => {
                                    if (a.usedCouponType > b.usedCouponType) return -1;
                                    if (a.usedCouponType < b.usedCouponType) return 1;
                                    return 0;
                                }
                            )
                            .sort((a,b) => b.couponId - a.couponId)
                            .map((coupon, index) => (
                            <Table.Row key={coupon.couponId}>
                                <Table.Td>{index + 1}</Table.Td>
                                <Table.Td>{coupon.issuedType === 'ISSUED' ? '발급형' : '다운로드형'}</Table.Td>
                                <Table.Td>{coupon.name}</Table.Td>
                                <Table.Td>{coupon.issuedDateStr}</Table.Td>
                                <Table.Td>{coupon.validDateStr}</Table.Td>
                                <Table.Td
                                    className={`${
                                        coupon.usedCouponType === 'USE_C'
                                            ? 'text-blue-500'
                                            : coupon.usedCouponType === 'USE_Y'
                                                ? 'text-red-500'
                                                : coupon.usedCouponType === 'USE_N'
                                                    ? 'text-gray-500'
                                                    : ''
                                    }`}
                                >
                                    {coupon.usedCouponType === 'DOWN_Y' ? (
                                        <>
                                            <button
                                                onClick={() =>
                                                    clickDownloadBtn(coupon.couponId)
                                                }
                                                className="outlined-gray-900 py-2 px-4"
                                            >
                                                다운
                                            </button>
                                        </>
                                    ) : (
                                        <>{
                                            coupon.usedCouponType === 'USE_C'
                                                ? '사용완료'
                                                : coupon.usedCouponType === 'USE_Y'
                                                    ? '사용가능'
                                                    : coupon.usedCouponType === 'USE_N'
                                                        ? '사용불가'
                                                        : '다운불가'
                                        }</>
                                    )}
                                </Table.Td>
                            </Table.Row>
                        ))}
                    </Table.Body>
                </Table>

                {/*<Pagination className="hidden md:flex">
                <Pagination.Label count={data.items.length} total={data.total}/>
                <Pagination.Nav basePath="/admin/inquiry" total={data.total}/>
            </Pagination>*/}
            </>
    );
};
